<lib-ph-bhp-elearning (childData)=onChildData($event)></lib-ph-bhp-elearning>
 
